(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["monet-format-identity"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', event => {
  const variant = event.detail?.variant;
  const formId = event.target?.getAttribute?.('id') || event.detail?.formId;
  if (!variant || !formId) return;
  document.querySelectorAll('[data-monet-format-identity]').forEach(panel => {
    if (panel.dataset.form !== formId) return;
    const variantId = String(variant.id);
    const showIdentity = panel.dataset.formatIds.split(',').includes(variantId);
    panel.hidden = !showIdentity;
    panel.querySelectorAll('[data-monet-format-photo]').forEach(photo => {
      photo.hidden = photo.dataset.variantId !== variantId;
    });
    const label = panel.querySelector('[data-monet-format-label]');
    if (label) label.textContent = variant.title;
    document.querySelectorAll('[data-monet-format-gallery]').forEach(gallery => {
      if (gallery.getAttribute('form') === formId) gallery.hidden = showIdentity;
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
